import IMInventoryEntry from './IMInventoryEntryModal';

export default IMInventoryEntry;
